import React from 'react';
import teej from '../../assets/eventsImage/teejevent.jpg';
import henna from '../../assets/eventsImage/henna.png';
import dashain from '../../assets/eventsImage/dashainevent.JPG';
import holi from '../../assets/eventsImage/holiEvent.JPG';

import './Event.css';

function Events() {
  return (
    <div className="events-page">
      <section className="calendar-section">
        <h2 className="calendar-heading">📅 Stay Updated with Upcoming Activities</h2>
        <p className="calendar-subheading">View our live calendar and never miss a celebration!</p>
        <iframe
          className="google-calendar"
          src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&showTitle=0&showPrint=0&showTabs=1&showCalendars=0&showTz=0&src=OWE1NGFlNTI2MjczOWM0MjFlYTI0YjYwN2Y1ZDI5NzNjYTU5OGY4MmQ2NjYwODM2YzE2NDc3YzQ5ODg4MDMwMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%233F51B5"
          allowFullScreen></iframe>
      </section>

      <section className="event-highlights">
        <h2 className="event-highlights-header">✨ Sparkling Event Spectacles</h2>

        <div className="event-card">
          <img src={teej} alt="Teej Celebration" className="event-image" />
          <div className="event-details">
            <h3>Teej Celebration — August 27, 2022</h3>
            <p>
              NSAS students joyfully celebrated Teej, a sacred festival dedicated to Lord Shiva and
              Parvati. This colorful event was full of dance, music, and fasting rituals,
              highlighting strength and sisterhood among Nepali women.
            </p>
          </div>
        </div>

        <div className="event-card reverse">
          <img src={henna} alt="Henna Fundraiser" className="event-image" />
          <div className="event-details">
            <h3>Henna Fundraiser — September 20, 2022</h3>
            <p>
              Traditional henna art was brought to SLU’s Student Union Breezeway as a cultural
              fundraiser, helping NSAS raise money for Dashain and Holi. The event brought art,
              curiosity, and cultural education to campus.
            </p>
          </div>
        </div>

        <div className="event-card">
          <img src={dashain} alt="Dashain Festival" className="event-image" />
          <div className="event-details">
            <h3>Dashain Celebration — October 8, 2022</h3>
            <p>
              Our biggest cultural night of the year! Students and community gathered to honor
              Dashain through food, performances, games, and Nepalese traditions. It symbolized the
              victory of good over evil.
            </p>
          </div>
        </div>

        <div className="event-card reverse">
          <img src={holi} alt="Holi Festival" className="event-image" />
          <div className="event-details">
            <h3>Holi Festival — March 4, 2023</h3>
            <p>
              A vibrant Holi bash filled with colors, laughter, and music! Held at the Pennington
              Center, it celebrated the arrival of spring and unity through joyful color play — a
              memory painted in hues of happiness.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Events;
